export const styles = theme => ({
  root: {
    marginBottom: "10vh",
  },
  carousel: {
    backgroundColor: "#dddddd22",
    padding: "10px",
  }
});